import React, { useState } from "react";
import ReactDOM from "react-dom";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/custom-calender-icon.svg";

const MonthYearPickerModal = () => {
  const [showModal, setShowModal] = useState(false);
  const currentDate = new Date();
  const [selectedDate, setSelectedDate] = useState({
    month: currentDate.toLocaleString('default', { month: 'long' }),
    year: currentDate.getFullYear(),
  });


  const months = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];

  const years = Array.from({ length: 50 }, (_, i) => 2024 - i);

  const handleDateChange = (month, year) => {
    setSelectedDate({ month, year });
    setShowModal(false);
  };

  const Modal = () => (
    <div style={styles.modalOverlay} onClick={() => setShowModal(false)}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.titleModal}>Select Month and Year</div>
        <div style={styles.selectors}>
          <select
            style={styles.select}
            value={selectedDate.month}
            onChange={(e) => handleDateChange(e.target.value, selectedDate.year)}
          >
            {months.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
          <select
            style={styles.select}
            value={selectedDate.year}
            onChange={(e) => handleDateChange(selectedDate.month, e.target.value)}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div style={styles.actions}>
          <button style={styles.button} onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button style={styles.button} onClick={() => setShowModal(false)}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.date} onClick={() => setShowModal(true)}>
        <div style={styles.icon}>
          <CalenderIcon style={{ height: "15px", width: "15px" }} />
        </div>
        <div style={styles.actualDate}>
          {selectedDate.month} {selectedDate.year}
        </div>
      </div>

      {/* Render the modal using ReactDOM.createPortal */}
      {showModal && ReactDOM.createPortal(<Modal />, document.body)}
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    display: "flex",
    backgroundColor: "white",
    border: "0.5px solid #ddd",
    padding: "4px 10px",
    borderRadius: "5px",
  },
  date: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '5px',
  },
  actualDate: {
    fontSize: '12px',
  },
  modalOverlay: {
    position: 'fixed', // Ensures modal takes full screen
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '300px',
    textAlign: 'center',
  },
  titleModal: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: "18px",
    marginBottom: "20px",
  },
  selectors: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  select: {
    padding: '10px',
    fontSize: '14px',
    width: '45%',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    padding: '10px 15px',
    border: 'none',
    backgroundColor: '#0B2C3C',
    color: 'white',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default MonthYearPickerModal;
